// extracted by mini-css-extract-plugin
export var backupIcon = "_oa-1";
export var image = "_oa-0";